import React, { useState, useEffect } from 'react'
import { Act_Header, Act_Body_end, Navbar, Footer } from '../container'
import { Helmet } from "react-helmet";

const ActvAlgotithia = () => {
    
  
    return (
      <div className='App'>
        <Navbar />
        <Act_Body_end />
        <Footer />
      </div>
    )
  }
  
  export default ActvAlgotithia
  